import * as PIXI from "pixi.js";

import markerCircleDark from "../img/circle_dark.png";
import markerCircleLight from "../img/circle_light.png";
import markerCircleTransparent from "../img/circulo-transparente.png";
import markerCircleBorder from "../img/circulo-borda.png";
import markerDisaster from "../img/fire.png";

import { useEffect, useState } from "react";

export default function useTextures(iconsElements) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      const { Assets } = PIXI;
      const processBase64 = (img) => {
        if (img?.includes("svg")) {
          const svgString = atob(img?.split("base64,")[1]);
          const container = document.createElement("div");
          container.innerHTML = svgString;
          const svgElement = container.querySelector("svg");

          if (svgElement) {
            svgElement.style.fill = "#ffffff";

            svgElement.style.height = "auto";
            const updatedSvgString = container.innerHTML;

            // Convert the updated SVG back to a base64 URL
            img = "data:image/svg+xml;base64," + btoa(updatedSvgString);
          }
        }

        return img;
      };

      const texList = iconsElements.map((iconElement) => ({
        id: iconElement?.id,
        src: processBase64(iconElement?.img),
      }));

      const marker = [
        { id: "marker_circle_dark", src: markerCircleDark },
        { id: "marker_circle_light", src: markerCircleLight },
        { id: "marker_circle_transparent", src: markerCircleTransparent },
        { id: "marker_disaster", src: markerDisaster },
        { id: "marker_circle_border", src: markerCircleBorder },
      ];
      const allTextures = [...texList, ...marker];
      allTextures.forEach(({ id, src }) => {
        if (!Assets.cache.has(id)) Assets.add(id, src);
      });

      await Promise.all(allTextures.map(({ id }) => Assets.load(id)));
      setReady(true);
    })();
  }, [iconsElements]);

  return ready;
}
